import { Tabs } from "antd";

const TabMenu = ({ items }) => {
	return (
		<div className="w-full h-full ">
			<Tabs
				size="small"
				type="card"
				className="w-full h-full p-0 m-0 text-xs font-semibold leading-normal text-[#282828] "
				defaultActiveKey="1"
				items={items}
			/>
		</div>
	);
};

export default TabMenu;
